import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useAuth } from "../../utils";

const NavBar = () => {
  const { isAuthenticated, logout } = useAuth(); // get authentication status and logout function

  const handleLogout = () => {
    logout();
  };

  return (
    <NavContainer>
      {isAuthenticated ? (
        <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
      ) : (
        <Link to="/login">
          <LoginButton>Login</LoginButton>
        </Link>
      )}
    </NavContainer>
  );
};

export default NavBar;

const NavContainer = styled.div`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
`;

const LoginButton = styled.button`
  padding: 10px 10px;
  margin-right: 2px;
  font-size: 1rem;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    transform 0.2s ease;

  &:hover {
    background-color: #0056b3;
    transform: scale(1.1);
  }
`;

const LogoutButton = styled.button`
  padding: 10px 10px;
  margin-right: 2px;
  font-size: 1rem;
  color: white;
  background-color: #dc3545;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #c82333;
    transform: translateY(1px);
  }
`;
